import { Col, Row } from "react-bootstrap";
import IconSvg from "../SharedComponents/IconSvg";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function AppHeader() {
  const { t } = useTranslation();
  const isTurkishSelected = i18next.language === "tr";
  const navigate = useNavigate();

  const location = useLocation();

  const SelectLanguage = (lang) => {
    i18next.changeLanguage(lang).catch((err) => {
      console.log(err);
    });
  };
  const IsVisibleLoginAndLangButtons = () => {
    if (
      location.pathname.includes("GoToApplication") ||
      location.pathname.includes("app") ||
      location.pathname.includes("demographyForm") ||
      location.pathname.includes("demoResult") ||
      location.pathname.includes("iresult") ||
      location.pathname.includes("tresult") ||
      location.pathname.includes("iwrapup") ||
      location.pathname.includes("twrapup")
    )
      return false;
    return true;
  };

  return (
    <Row
      className={"h-100 justify-content-start"}
      style={{ background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)" }}
    >
      <Col xs={"auto"} md={{ offset: 2, span: "auto" }} className={"align-content-center"}>
        <Row className={"align-items-center ps-3 mx-0"}>
          <Col xs={"auto"} className={"pe-2 px-0 align-content-center"}>
            <IconSvg icon="cp-logo" height={40} width={40} fill="#ffffff" />
          </Col>
          <Col xs={"auto"} className={"text-32 lh-1 text-color-white fw-medium px-0 align-content-center"}>
            Cus-Pro
          </Col>
        </Row>
      </Col>
      {IsVisibleLoginAndLangButtons() && (
        <Col xs={"auto"} lg={3} className={"align-content-center"} style={{ marginLeft: "auto", marginRight: "15px" }}>
          <Row xs={"auto"}>
            <Col className={"px-4 pt-2"}>
              <Row>
                <Col
                  className={(isTurkishSelected && "language-button d-none d-sm-block") + " px-1 py-0 btn border-0"}
                  onClick={() => {
                    SelectLanguage("tr");
                  }}
                >
                  <IconSvg icon="flag-tr" height={24} width={24} />
                </Col>
                <Col className={"d-none d-sm-block px-0"}>
                  <IconSvg icon="dot" height={20} width={20} />
                </Col>
                <Col
                  className={(!isTurkishSelected && "language-button d-none d-sm-block") + " px-1 py-0 btn border-0"}
                  onClick={() => {
                    SelectLanguage("en");
                  }}
                >
                  <IconSvg icon="flag-uk" height={24} width={24} />
                </Col>
              </Row>
            </Col>
            {!(location.pathname.includes("/login") || location.pathname.includes("/register")) && (
              <Col xs={"auto"} className={"justify-content-end"}>
                <Row className={"justify-content-md-end"}>
                  <div onClick={() => navigate("/login")} style={{ height: 24 }}>
                    <Row className={"px-4 py-2 rounded-1 align-content-center"} style={{ color: "#F6C344" }}>
                      <Col style={{ paddingLeft: 0 }}>
                        <IconSvg icon={"login"} width={24} height={24} />
                      </Col>
                      <Col className={"d-none d-sm-block fw-semibold px-0"}>{t("login")}</Col>
                    </Row>
                  </div>
                </Row>
              </Col>
            )}
          </Row>
        </Col>
      )}
    </Row>
  );
}
